import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import TextWithLabel from '@/components/TextWithLabel/TextWithLabel'
import { useAllEducationLevels } from '@/queries/useAllEducationLevels'

import styles from './Summary.module.scss'
import type { CurriculumForm } from '../../hooks/useCurriculumForm'
import { useAllCoursesOptions } from '../../queries/useAllCoursesOptions'
import BasketSummaryTable from '../BasketSummaryTable'

const Summary = () => {
  const { t } = useTranslation('curriculumsManagement')
  const form = useFormContext<CurriculumForm>()

  const educationLevelId = form.getValues('educationLevel')
  const name = form.getValues('name')
  const aim = form.getValues('aim')
  const baskets = form.getValues('baskets')

  const { data: educationLevels } = useAllEducationLevels()
  const { data: courses } = useAllCoursesOptions({ educationLevelId })

  const basicInfo = [
    {
      label: t('label.education-level'),
      value: educationLevels?.map?.[educationLevelId]?.name
    },
    {
      label: t('label.name'),
      value: name
    },
    {
      label: t('label.aim'),
      value: t(`aim.${aim}`)
    }
  ]

  return (
    <div className={styles.container}>
      <div className={styles.basicInformation}>
        <h2 className={styles.header}>{t('header.basic-information')}</h2>
        <div>
          {basicInfo.map((item, index) => (
            <TextWithLabel
              key={index}
              label={item.label}
              text={item.value}
              variant="horizontal-full-row"
              size="small"
            />
          ))}
        </div>
      </div>
      {baskets.map((basket, index) => (
        <BasketSummaryTable
          key={index}
          id={index.toString()}
          title={t(`header.${basket.type}-basket`)}
          shouldLinkToCourse={false}
          data={basket.courses.map(course => ({
            course: course.course
              ? {
                  id: course.course,
                  name:
                    courses?.find(c => c.value === course.course)?.label || ''
                }
              : null,
            timeUnit: course.timeUnit,
            semesters: course.semesters.map(semester => semester.hours),
            total: course.semesters.reduce(
              (acc, curr) => acc + (curr.hours || 0),
              0
            )
          }))}
        />
      ))}
    </div>
  )
}

export default Summary
